// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/VatCode.yaml
// Generated: 2026-05-30T15:42:37.833Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateVatCode, UpdateVatCode, VatCode } from '@/types/finance/VatCode';

/**
 * VatCode Service
 * CRUD operations for VatCode via the ABP API.
 */
export const vatCodeService = new EntityService<VatCode, CreateVatCode, UpdateVatCode>(
  '/api/finance/vatcode',
  'VatCode',
);
